import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isCustomerLoggedIn } from "../utils/CustomerAuth";

const CustomerProtectedRoute = () => {
  const location = useLocation();

  if (!isCustomerLoggedIn()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};

export default CustomerProtectedRoute;
